const Pointer = () => {
  return (
    <svg
      className="w-full h-full"
      viewBox="0 0 34 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2514_16150)">
        <path
          d="M33.9454 17.4793C33.8713 18.9318 33.4798 20.317 32.9562 21.665C32.2773 23.4169 31.3904 25.0625 30.4012 26.6532C28.5021 29.707 26.3033 32.5411 24.0322 35.3186C22.0344 37.7613 20.0348 40.2005 18.0388 42.6449C17.7302 43.0222 17.4446 43.419 17.1483 43.8069C17.1007 43.8707 17.0478 43.9309 16.9914 44C16.4589 43.3198 15.9493 42.6467 15.415 41.9913C13.7593 39.9631 12.0912 37.9438 10.4302 35.9191C8.34604 33.3772 6.30592 30.8017 4.47916 28.0649C3.19549 26.1395 2.02291 24.1502 1.14832 21.9998C0.390111 20.1364 -0.0912646 18.2144 0.0145323 16.1774C0.130909 13.9242 0.635207 11.7685 1.60854 9.72967C2.83049 7.16652 4.57261 5.03381 6.84725 3.34571C9.0778 1.6895 11.5711 0.646172 14.3095 0.215733C17.1572 -0.232419 19.9537 0.0155706 22.6762 0.979186C25.6456 2.0296 28.1371 3.77969 30.142 6.2153C31.8065 8.23819 32.942 10.5303 33.538 13.0881C33.8748 14.5318 34.0212 15.9985 33.9454 17.4776V17.4793Z"
          fill="#22CDC6"
        />
        <path
          d="M12.3008 19.2969V23.8344C12.3008 23.9751 12.3542 24.1101 12.4492 24.2096C12.5442 24.3092 12.673 24.3651 12.8074 24.3651H21.9258C22.0601 24.3651 22.189 24.3092 22.284 24.2096C22.379 24.1101 22.4324 23.9751 22.4324 23.8344V19.2969"
          stroke="#FEFEFE"
          strokeWidth="0.709747"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6822 12.6875H22.0539C22.1638 12.6884 22.2705 12.7263 22.3582 12.7956C22.446 12.8649 22.5102 12.9619 22.5415 13.0723L23.447 16.4024H11.2891L12.1946 13.0723C12.2258 12.9619 12.29 12.8649 12.3778 12.7956C12.4656 12.7263 12.5723 12.6884 12.6822 12.6875V12.6875Z"
          stroke="#FEFEFE"
          strokeWidth="0.709747"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.3417 16.4043V17.4657C15.3417 18.0287 15.1282 18.5686 14.7482 18.9668C14.3682 19.3649 13.8528 19.5885 13.3154 19.5885C12.778 19.5885 12.2626 19.3649 11.8826 18.9668C11.5025 18.5686 11.2891 18.0287 11.2891 17.4657V16.4043"
          stroke="#FEFEFE"
          strokeWidth="0.709747"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.3925 16.4043V17.4657C19.3925 18.0287 19.179 18.5686 18.799 18.9668C18.419 19.3649 17.9036 19.5885 17.3662 19.5885C16.8287 19.5885 16.3133 19.3649 15.9333 18.9668C15.5533 18.5686 15.3398 18.0287 15.3398 17.4657V16.4043"
          stroke="#FEFEFE"
          strokeWidth="0.709747"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.4472 16.4043V17.4657C23.4472 18.0287 23.2337 18.5686 22.8537 18.9668C22.4737 19.3649 21.9583 19.5885 21.4208 19.5885C20.8834 19.5885 20.368 19.3649 19.988 18.9668C19.608 18.5686 19.3945 18.0287 19.3945 17.4657V16.4043"
          stroke="#FEFEFE"
          strokeWidth="0.709747"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2514_16150">
          <rect width="33.9649" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Pointer;
